import { TextFieldStyled } from '@nike/nike-design-system-components';
import PropTypes from 'prop-types';
import React from 'react';
import { useController } from 'react-hook-form';

import { AnyType } from '../../../../utils/propTypesUtils';

/**
 * TextField wrapper that supports showing placeholder with shouldMakeActive.
 * Uses slots.InputSlot approach similar to MultipleCurrencyInput to bypass
 * TextFieldStyled's placeholder hiding when label is active.
 */

/**
 * @param {import('@nike/nike-design-system-components/types/src/components/TextInput/TextField/TextField').TextFieldProps} props
 */
export function TextFieldWithPlaceholder({
  control,
  defaultValue,
  name,
  direction,
  placeholder,
  ...rest
}) {
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { error },
  } = useController({
    control,
    defaultValue,
    name,
  });

  return (
    <TextFieldStyled
      error={!!error}
      errorMessage={error?.message}
      style={{ textAlign: 'initial' }}
      slots={{
        InputSlot: (
          <input
            ref={ref}
            id={rest.id}
            name={name}
            value={value || ''}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            style={{
              border: 'none',
              paddingInline: '12px 12px',
              fontSize: '16px',
              fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
              lineHeight: '24px',
              width: '100%',
              outline: 'none',
              direction,
            }}
          />
        ),
      }}
      {...rest}
    />
  );
}

TextFieldWithPlaceholder.defaultProps = {
  defaultValue: null,
  direction: 'ltr',
  placeholder: '',
};

TextFieldWithPlaceholder.propTypes = {
  control: AnyType.isRequired,
  defaultValue: PropTypes.string,
  name: PropTypes.string.isRequired,
  direction: PropTypes.string,
  placeholder: PropTypes.string,
};
